import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import { CORPORATION_IDS_TO_EXCLUDE_NON_US_ADDRESSES } from './constants';
import { SourceRecordStatusCounts, WebhookStatusCounts } from './types';

export function useSourceRecordAggregate(corporationId: number): {
  data: SourceRecordStatusCounts | undefined;
  error: Error;
  isLoading: boolean;
  mutate: () => void;
} {
  const shouldExcludeNonUSAddresses =
    CORPORATION_IDS_TO_EXCLUDE_NON_US_ADDRESSES.includes(corporationId);

  const { data, error, isLoading, mutate } = useSWR<{
    success: boolean;
    data: SourceRecordStatusCounts;
  }>(
    `new-sales-tax/source-record/aggregate?corporationId=${corporationId}&${shouldExcludeNonUSAddresses ? 'includeNonUSAddresses=false' : ''}`,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data: data?.data,
    error,
    isLoading,
    mutate,
  };
}

export function useWebhookLogStatusCountsByCorporationId(
  corporationId: number
): {
  data:
    | {
        data: WebhookStatusCounts;
        rootfiCompanyId: number;
      }[]
    | undefined;
  error: Error;
  isLoading: boolean;
  mutate: () => void;
} {
  const { data, error, isLoading, mutate } = useSWR<{
    success: boolean;
    data: {
      data: WebhookStatusCounts;
      rootfiCompanyId: number;
    }[];
  }>(
    `integration-sync/status/aggregate?corporationId=${corporationId}`,
    SWRFetcher({
      method: 'GET',
    })
  );
  return {
    data: data?.data,
    error,
    isLoading,
    mutate,
  };
}
